import { KEY_CODES } from "../../../gearshiftGame/constants";

/**
 * Separated phases to tutorial.
 */
export function buildPhase0(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      trial_duration: newGame.targetLaunchDelay,
      on_load: () => newGame.startPhase0(),
      on_finish: (data) => {
        data.name = "initializeTarget";
        data.driverSpeed = newGame.driverCarSpeed;
        data.distanceToTarget = newGame.driverDistanceToTarget;
        data.trialStart = {
          name: "trialStart",
          driverSpeed: newGame.driverCarSpeed,
          timestamp: jsPsych.data.get().last(2).values()[0].time_elapsed,
        };
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}

export function buildPhase1(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase1(),
      on_finish: (data) => {
        data.name = "engageTarget";
        data.cueCarOn = {
          name: "cueCarOn",
          driverSpeed: newGame.driverCarSpeed,
          timestamp: jsPsych.data.get().last(1).values()[0].time_elapsed,
          distanceToTarget: newGame.driverDistanceToTarget,
          csi: newGame.csi,
        };
      },
    },
  ];
}

export function buildPhase2(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      trial_duration: newGame.csi,
      on_load: () => newGame.startPhase2(),
      on_finish: (data) => {
        data.name = "licensePlateOn";
        data.timestamp = jsPsych.data.get().last(2).values()[0].time_elapsed;
        data.driverSpeed = newGame.driverCarSpeed;
        data.distanceToTarget = jsPsych.data.get().last(2).values()[0].distanceToTarget;
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}

export function buildPhase3(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase3(),
      on_finish: (data) => {
        data.name = "responseKeyPressed";
        data.response_keypress_time = data.time_elapsed;
        data.keyCode = KEY_CODES[data.response_event_code ?? data.response] ?? null;
        data.responseTime = data.time_elapsed - jsPsych.data.get().last(2).values()[0].time_elapsed;
        data.driverSpeed = newGame.driverCarSpeed;
        // displayLicense()/captureLicensePlateOnTime() only run once startPhase3's on_load
        // fires, which is after the "licensePlateOn" (phase 2) row already saved - so this
        // is the earliest row where the value is actually available
        data.license_plate_on_time = newGame.licensePlateOnTime;

        if (data.crashed) jsPsych.endCurrentTimeline();
        else data.crashed = false;
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}

export function buildPhase4(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase4(jsPsych.data.get().last(1).values()[0].keyCode),
      on_finish: (data) => {
        data.name = "driverInResponseLane";
        data.driverSpeed = newGame.driverCarSpeed;
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}

export function buildPhase5(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase5(),
      on_finish: (data) => {
        data.name = "packageDisappears";
        data.driverSpeed = newGame.driverCarSpeed;
        data.emotion = newGame.emotion;
        data.packageInTargetLane = {
          timestamp: jsPsych.data.get().last(2).values()[0].time_elapsed,
          driverSpeed: newGame.driverCarSpeed,
          packageDistance: newGame.packageDistanceToTarget,
        };
        data.targetDisappears = {
          timestamp: newGame.targetCarDisappearTimestamp,
          driverSpeed: newGame.driverCarSpeed,
        };
        data.emotionReaction = {
          emotion: newGame.emotion,
          driverSpeed: newGame.driverCarSpeed,
          timestamp: jsPsych.data.get().last(1).values()[0].time_elapsed - newGame.feedbackDuration,
        };
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}

export function buildPhase7(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase7(),
      on_finish: (data) => {
        data.name = "driverAtCenter";
        data.driverToCenter = {
          timestamp: jsPsych.data.get().last(2).values()[0].time_elapsed,
          driverSpeed: newGame.driverCarSpeed,
        };
        data.driverSpeed = newGame.driverCarSpeed;
        // Tutorial-only: skip assigning score for these phase trials
        // SCORE.assignScore(data);
      },
    },
  ];
}
